"use client";

import { useEffect } from "react";
import { APP_VERSION } from "@/lib/config";

export default function NotificationBootstrap() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    const swUrl = `/sw.js?v=${encodeURIComponent(APP_VERSION)}`;

    navigator.serviceWorker
      .register(swUrl, { updateViaCache: "none" })
      .then((registration) => {
        void registration.update();
      })
      .catch((error) => console.error("Service Worker registration failed:", error));
  }, []);

  return null;
}
